module.exports = __webpack_public_path__ + "static/img/bg_1.5f91da3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/bg_1.png
// module id = rkY+
// module chunks = 1